<div class="flex flex-col items-center gap-lg">
  @switch (view()) {
    @case ('month') {
      <sb-calendar
        [months]="2"
        [date]="date()"
        [minDate]="minDate()"
        [maxDate]="maxDate()"
        [showYearNavigation]="true"
        [allowZoomOut]="false"
        (dateChange)="onDateChange($event)"
      >
        <ng-template #dayTemplate let-day="day">
          <absence-calendar-day [absences]="getDayAbsences(day)" [day]="day"></absence-calendar-day>
        </ng-template>
      </sb-calendar>
    }
    @case ('year') {
      <absence-year
        class="w-full"
        [year]="year()"
        [pendingAbsences]="pendingAbsences()"
        [reviewedAbsences]="reviewedAbsences()"
      />
    }
  }

  <div class="ml-auto flex items-start justify-between gap-lg">
    <sb-legend [items]="legendItems()"></sb-legend>
    <div class="flex shrink-0 items-center gap-md">
      <sb-legend
        [items]="[
          {
            label: 'Approved' | translate,
            color: 'var(--colors-foreground-support)',
          },
          {
            label: 'Pending' | translate,
            color: 'var(--colors-foreground-support)',
            outline: true,
          },
        ]"
      ></sb-legend>
      <div sbDivider [direction]="'vertical'" class="self-stretch"></div>
      <a
        class="flex items-center gap-1 text-sm text-brand"
        [routerLink]="['', { outlets: { modal: ['calendar-sync'] } }]"
      >
        <sb-icon [name]="'calendar-2-regular'" />
        {{ 'Add to calendar' | translate }}
      </a>
    </div>
  </div>
</div>
